import Keycloak from 'keycloak-js'
import API from './api'

// SPA pública (sin secret) -- Authorization Code + PKCE, es lo que
// corresponde para un front sin backend-for-frontend propio (ver
// CLAUDE.md, sección Keycloak). El token vive en memoria en esta instancia,
// no en localStorage.
// REACT_APP_KEYCLOAK_URL se graba en el build. Si llega sin protocolo (p. ej. "auth.darient.com"),
// el navegador la toma como ruta relativa y entra en un bucle de redirecciones que termina en un 400
// (chronus.darient.com/auth.darient.com/realms/...). Se normaliza para que no dependa de cómo se cargó.
const normalizarUrl = (valor) => {
  const url = String(valor || '').trim().replace(/\/+$/, '')
  return url && !/^https?:\/\//i.test(url) ? `https://${url}` : url
}

const keycloak = new Keycloak({
  url: normalizarUrl(API.keycloakUrl),
  realm: API.keycloakRealm,
  clientId: API.keycloakClientId
})

export default keycloak
